var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "104px",
    viewBox: "0 0 101 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Health@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Landing-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Promo-Landing",
    transform: "translate(-85.000000, -1828.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1689.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(84.957031, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1E83B1",
    points: "15.1139948 15.2887293 0.215113636 51.5663304 14.5221406 88.5019859 50.4761187 103.524429 85.9827109 87.3926941 100.876932 51.1291942 86.7330143 15.2558266 50.7650554 0.233383862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2628576,45.0319969 C69.9909862,39.271214 65.5459041,34.3919807 59.876046,34.3474215 C56.5870947,34.32183 53.7253699,35.8817034 51.6073022,38.8587402 C51.1860973,39.4503541 50.8347419,40.0419678 50.5460102,40.59113 C50.2572786,40.0419678 49.9059232,39.4503541 49.4847183,38.8587402 C47.3838118,35.9057894 44.5537,34.3471204 41.2960606,34.3471204 C41.2695659,34.3471204 41.2427702,34.3471204 41.2159745,34.3474215 C35.5473206,34.3916796 31.1010343,39.2697086 30.8291629,45.0319969 C30.4871408,52.2903306 36.2024614,57.1508972 44.8535714,64.5085859 C46.426391,65.8462654 48.0528021,67.2294073 49.7848908,68.7447214 L50.5460102,69.4107009 L51.3074307,68.7447214 C53.0392183,67.2294073 54.6656295,65.8462654 56.2384491,64.5085859 C64.8898601,57.1508972 70.6051807,52.2903306 70.2628576,45.0319969 Z M54.7405973,62.7469918 C53.3932834,63.8925849 52.0071307,65.0715975 50.5460102,66.3409328 C49.0848897,65.0715975 47.6987371,63.8925849 46.3517242,62.7469918 C41.8298678,58.9013515 38.2398409,55.8511533 35.9242675,52.8449122 L42.1303415,52.8449122 L43.7079783,48.1120017 L48.1166302,59.1331798 L51.2607641,52.8449122 L65.167753,52.8449122 C62.8500721,55.854164 59.251916,58.9103838 54.7405973,62.7469918 Z M66.6833683,50.5326506 L49.8315576,50.5326506 L48.3511682,53.4937303 L43.5104726,41.3922925 L40.4635862,50.5326506 L34.4086522,50.5326506 C33.4518336,48.7403468 33.0511018,47.0010322 33.1390159,45.1409864 C33.3618119,40.4189147 36.9175163,36.6934035 41.234039,36.659382 L41.2966628,36.659382 C43.7889676,36.659382 45.8970999,37.832373 47.563253,40.1467422 C48.8876851,41.9863149 49.4257075,43.8818877 49.431729,43.9038662 L50.5460102,47.9668832 L51.6608937,43.9017587 C51.6807646,43.8291995 53.7178431,36.659382 59.7971642,36.659382 C59.8173362,36.659382 59.8378094,36.659382 59.8579815,36.6596831 C64.1745042,36.6934035 67.7305096,40.4189147 67.9530046,45.1409864 C68.0409187,47.0010322 67.6401869,48.7403468 66.6833683,50.5326506 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.57661f43399193da0fa361b025fdb618.svg";
export { ForwardRef as ReactComponent };